module.exports = fox._r("images/press/icon-social-ln.png", __webpack_public_path__ + "_/common/images/press/icon-social-ln.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-social-ln.png
// module id = 385
// module chunks = 2